import _toConsumableArray from "D:/xampp/htdocs/SNS_Thai/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import $ from 'jquery';
import getPx from '@/utils/getPx';
import { userCheck, userInfo, userRegister as _userRegister, myCategories } from '@/api/mg';
export default {
  watch: {
    '$route': function $route(to, from) {
      var isBack = this.$router.isBack; //  监听路由变化时的状态为前进还是后退
      console.log(from.meta.index, to.meta.index);
      if (to.meta.index && from.meta.index) {
        if (to.meta.index > from.meta.index) {
          // 设置动画名称
          this.transitionName = 'slide-left';
        } else {
          this.transitionName = 'slide-right';
        }
        return;
      }
      if (isBack) {
        this.transitionName = 'slide-right';
      } else {
        this.transitionName = 'slide-left';
      }
      this.$router.isBack = false;
    }
  },
  data: function data() {
    return {
      themeData: '',
      leftIcon: require('../../assets/images/Search.png'),
      isShowWrap: false,
      transitionName: '',
      themeArr: [],
      // arr: ['Club', 'Activity', 'Video', 'News'],
      arr: ['Club', 'Activity', 'News'],
      // activeName: localStorage.getItem('activeName') || 'Club',
      activeName: 'Club',
      searchTxt: '',
      isShowPostPop: false,
      show: false
    };
  },
  created: function created() {
    var _this = this;
    var params = JSON.parse(localStorage.getItem('appParams'));
    this.activeName = localStorage.getItem('activeName') || 'Club';
    this.tabChange(this.activeName);
    // const checkParams = { appUserId: this.uuid || '00000000000000000000000000000000000000001234567899' }
    var checkParams = {
      appUserId: params.userId
    };
    var registerParams = {
      nickname: params.nickname || localStorage.getItem('nickname'),
      avatar: params.avatar || localStorage.getItem('avatar'),
      uuid: params.userId,
      isOwner: params.isOwner || localStorage.getItem('isOwner')
    };
    if (localStorage.getItem('socialToken')) {
      // this.getThreadList(threadListParams)
      this.getMyCategories();
      this.show = true;
      return;
    }
    userCheck(checkParams).then(function (res) {
      if (res.Code === 0) {
        localStorage.setItem('socialToken', res.Data.accessToken);
        _this.$store.state.socialToken = res.Data.accessToken;
        _this.getUserInfo({
          pid: res.Data.uid
        });
      } else {
        _this.$dialog.confirm({
          title: 'Confirm authorization?',
          confirmButtonText: 'yes',
          cancelButtonText: 'no'
          // message: '弹窗内容'
        }).then(function () {
          _this.userRegister(registerParams);
        }).catch(function () {
          _this.nativeBack();
        });
      }
    });
  },
  mounted: function mounted() {
    var that = this;
    this.$nextTick(function () {
      $('.wrap').on('click', function () {
        that.isShowPostPop = false;
        that.isShowWrap = false;
      });
      // $(this.$refs.tabs.$el).innerHeight($(window).height() - $('.search').innerHeight() - getPx(102) - $('.van-tabs__wrap').innerHeight())
      // $(this.$refs.tabs.$el).height($(window).height() - $('.search').innerHeight() - $('.van-tabs__wrap').height())
    });
  },
  beforeDestroy: function beforeDestroy() {
    // $(window).off('click')
  },
  methods: {
    nativeBack: function nativeBack() {
      var u = navigator.userAgent; // 判断手机类型
      if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
        window.Android.back();
      } else if (u.indexOf('iPhone') > -1 || u.indexOf('iPad') > -1) {
        this.$bridge.callhandler('back', null, function (response) {
          this.$toast(response + 'ios');
        });
      }
    },
    getMyCategories: function getMyCategories(params) {
      var _this2 = this;
      myCategories(params).then(function (res) {
        if (res.Code === 0) {
          _this2.themeArr = [].concat(_toConsumableArray(_this2.arr), _toConsumableArray(res.Data.category));
          var flag = _this2.themeArr.every(function (item, index) {
            return item !== localStorage.getItem('activeName');
          });
          if (flag) {
            _this2.activeName = 'Club';
            _this2.tabChange('Club');
          }
          console.log(_this2.themeArr, 'this.themeArr');
        } else {
          _this2.$toast(res.Message);
        }
      });
    },
    getUserInfo: function getUserInfo(params) {
      var _this3 = this;
      userInfo(params).then(function (res) {
        if (res.Code === 0) {
          localStorage.setItem('userId', res.Data.id);
          localStorage.setItem('pid', res.Data.group.pid);
          _this3.show = true;
          _this3.getMyCategories();
          // this.getThreadList(threadListParams)
        } else {
          _this3.$toast(res.Message);
        }
      });
    },
    userRegister: function userRegister(params) {
      var _this4 = this;
      _userRegister(params).then(function (res) {
        if (res.Code === 0) {
          localStorage.setItem('socialToken', res.Data.accessToken);
          _this4.$store.state.socialToken = res.Data.accessToken;
          console.log(_this4.$store.state.socialToken, 'this.$store.state.socialToken');
          _this4.getUserInfo({
            pid: res.Data.uid
          });
        } else {
          _this4.$toast(res.Message);
        }
      });
    },
    showPostPop: function showPostPop() {
      this.isShowPostPop = true;
      this.isShowWrap = true;
    },
    toChoose: function toChoose() {
      this.$router.push({
        path: '/social/choose'
      });
    },
    toScan: function toScan() {
      this.$toast('开发中...');
    },
    toPostArticle: function toPostArticle() {
      this.$toast('开发中...');
      // this.$router.push({ path: '/social/postArticle' })
    },
    toPost: function toPost() {
      this.$router.push({
        path: '/social/post'
      });
    },
    toSearch: function toSearch() {
      this.$router.push({
        path: '/social/search'
      });
    },
    tabChange: function tabChange(name, title) {
      // this.themeData = ''
      // const index = this.themeArr.indexOf(name)
      // threadListParams['filter[categoryids][0]'] = index + 1
      // this.getThreadList(threadListParams)
      var path = name.toLowerCase();
      // console.log(this.$router.history.current.path, 'this.$router.path')
      if (this.$router.history.current.path !== "/social/".concat(path)) {
        this.$router.replace({
          path: "/social/".concat(path)
        });
      }
      localStorage.setItem('activeName', name);
    }
  }
};